// extracted by mini-css-extract-plugin
module.exports = {"CustomCheckbox":"CustomCheckbox_CustomCheckbox__2Ht1R","Checkmark":"CustomCheckbox_Checkmark__K2zGO"};